// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1b_Uu","info":"PatientInfo_info___w0h1"};